import { faCircleCheck, faCircleXmark, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row, Tab, Table, Tabs, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import CancelDialog from '../CancelDialog';
import Dialog_IRN from '../Dialog_IRN';

function Tran_si() {
    const taxClassOPtions = [{ value: 0, label: "Select" },
    { value: 1, label: "Gst" },
    { value: 2, label: "Unregistered" },
    { value: 3, label: "Gst Excluded" }];
    const productRef = useRef();
    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [key, setKey] = useState("INFO");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [accountFilter, setAccountFilter] = useState(null);

    const [counter, setCounter] = useState(0);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [hdrDate, setHdrDate] = useState(new Date());
    const [radioType, setRadioType] = useState("N");
    const [siLocation, setSILocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [siNewDate, setSINewDate] = useState(new Date());
    const [siSrnoFrom, setSISrnoFrom] = useState("");
    const [siSrnoTo, setSISrnoTo] = useState("");
    const [siFromDate, setSIFromDate] = useState(new Date());
    const [siToDate, setSIToDate] = useState(new Date());
    const [siList, setSIList] = useState([]);
    const [siParty, setSIParty] = useState(null);

    const [nParty, setNParty] = useState(null);
    const [nShipTo, setNShipTo] = useState(null);
    const [nBillDate, setNBillDate] = useState(null);
    const [nPODate, setNPODate] = useState(null);
    const [nManualBill, setNManualBill] = useState("");
    const [nReverseCharge, setNReverseCharge] = useState("1");
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [nState, setNState] = useState();
    const [nStateReceiver, setNStateReceiver] = useState(null);
    const [nStateSupplier, setNStateSupplier] = useState(null);
    const [nGstin, setNGstin] = useState("");
    const [nTaxClass, setNTaxClass] = useState("");

    const [siLocationValue, setSILocationValue] = useState(0);
    const [siStateValue, setSIStateValue] = useState(0);
    const [siStateType, setSIStateType] = useState("");
    const [siStateName, setSIStateName] = useState("");
    const [hdrLocation, setHdrLocation] = useState(0);
    const [scrMode, setScrMode] = useState("");
    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });

    const [pAccount, setPAccount] = useState(null);
    const [pAmount, setPAmount] = useState("");
    const [pFCgst, setPFCgst] = useState("");
    const [pFIgst, setPFIgst] = useState("");
    const [pFSgst, setPFSgst] = useState("");
    const [pTds, setPTds] = useState("");
    const [pTds1, setPTds1] = useState("");
    const [pSac, setPSac] = useState("");
    const [pTaxable, setPTaxable] = useState("");

    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);
    const [productList, setProductList] = useState([]);
    const [productLineNo, setProductLineNo] = useState(1);
    const [pSgstCalc, setPSgstCalc] = useState("");
    const [pCgstCalc, setPCgstCalc] = useState("");
    const [pIgstCalc, setPIgstCalc] = useState("");
    const [gstDisable, setGstDisable] = useState(false);


    const [disableOtherCharge, setDisableOtherCharge] = useState(true);

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [pdAccountOptions, setPdAccountOptions] = useState([]);
    const [pdAccountValue, setPdAccountValue] = useState("");
    const [pdGroupValue, setPdGroupValue] = useState(0);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentLineNo, setPaymentLineNo] = useState(1);
    const [paymentData, setPaymentData] = useState([]);

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [nPono, setNPono] = useState("");
    const [nEwayBillNo, setNEwayBillNo] = useState('');
    const [nPaymentDueDate, setNPaymentDueDate] = useState(new Date());
    const [pQuantity, setPQuantity] = useState("");
    const [pRate, setPRate] = useState("");
    const [nManualNo, setNManualno] = useState(null);
    const [pservice, setPService] = useState("N");
    const [pdescGdSrv, setPdescGdSrv] = useState("");
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [pdRemark, setPdRemark] = useState("");
    const [compareData, setCompareData] = useState([]);

    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");
    const [cancelButtonView, setCancelButtonView] = useState(true);
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);

    const [isIrnGenerated, setIsIrnGenerated] = useState("0");
    const [irnObj, setIrnObj] = useState({ irn: "", ackdate: "", acknum: "", signedqr: "" });
    const [isIrnCancelled, setIsIrnCancelled] = useState("0");
    const [irnCancelDate, setIrnCancelDate] = useState("");
    const [irnCancelReason, setIrnCancelReason] = useState("");
    const [irnCancelLabel, setIrnCancelLabel] = useState("");
    const [irnCancelDeclaration, setIrnCancelDeclaration] = useState(false);
    const [isIrnApplicable, setIsIrnApplicable] = useState("N");
    const [irnCancelReasonHdr, setIrnCancelReasonHdr] = useState("");
    const [irnCancelRemarkHdr, setIrnCancelRemarkHdr] = useState("");

    const [irnCancelReasonSelect, setIrnCancelReasonSelect] = useState("");
    const [isMsgBoxCancelBill, setMsgBoxCancelBill] = useState(false);
    const [msgTextCancelBill, setMsgTextCancelBill] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");


    const [hdrDateYmd, setHdrDateYmd] = useState("");


    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setSILocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_SI'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserCancelBillRight(resp);
            }
        });
        // Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", pProduct], result => {
        //     setIsdOptions(JSON.parse(result));
        // });
        // Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
        //     setResidentOptions(JSON.parse(result));
        // });
        // Common.callApi(Common.apiState, [sid, "getState", 1], result => {
        //     setStateOptions(JSON.parse(result));
        // });
    }, []);

    const handleLocationChange = (value) => {
        console.log("this is location Value", value);
        setSILocation(value);

        var id = value.id;
        var location = id.split("^");

        setSILocationValue(location[1]);
        setSIStateValue(location[3] == null ? 0 : location[3]);
        setSIStateType(location[4]);
        setSIStateName(location[5] === "" ? "Select" : location[5]);
        setHdrLocation(location[2]);

        setNStateSupplier({
            id: location[3] == null ? 0 : location[3],
            label: location[5] === "" ? "Select" : location[5]
        });

        sessionStorage.activeBranch = location[1];
        setIsBranchDisableForAddNew(location[9]);
    };



    const handleProductAccountChange = (value) => {
        setSIParty(value);
    }

    const handlePartyChange = (value) => {
        setNParty(value);
        setNShipTo(value);
        var id = value.id;
        var location = id.split("^");
        setNStateReceiver({
            id: location[3] == null ? 0 : location[3],
            label: location[4] === "" ? "Select" : location[4]
        });
        setNGstin(location[9]);
        const matchingOption = taxClassOPtions.find(val => val.value == location[14]);
        if (matchingOption) {
            setNTaxClass(matchingOption.value);
        } else {
            console.log("No match found for the value in location[10]");
        }
        if (location[3] === nStateSupplier.id) {
            setGstDisable(false);
        } else {
            setGstDisable(true);
        }
        //setNState({ value: corp[3], label: corp[4] });
    }
    const handleShipChange = (value) => {
        console.log("this is value of shipoooiung ", value)
        setNShipTo(value);
    }

    const handleAccountFilter = (value) => {
        setAccountFilter(value);
    }

    const handleTabChange = (k) => {
        setKey(k);
        // if (k === "PAYMENT") {
        //     var amt = 0;
        //     for (var i = 0; i < paymentData.length; i++) {
        //         amt += paymentData[i].tp_amount * 1;
        //     }
        //     setPdAmount(1 * pTotalAmount - amt);
        //     const obj = {
        //         nCorporate: nCorporate
        //     }
        //     Common.callApi(Common.apiTranPP, [sid, "getcorporate", JSON.stringify(obj)], result => {
        //         setPdAccountOptions(JSON.parse(result));
        //     });
        // }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const otherChargeChange = (v) => {
        // Common.validateDecValue(v, setPOtherCharges);
        // calcInvoice(productList, v);
        Common.validateDecValue(v, setPOtherCharges);
        // if (Common.isPurelyNumeric(v.trim())) {
        calcInvoice(productList, v, (pRoundOff ?? 0));
        // }
    }

    const roundOffChange = (v) => {
        Common.validateDecValue(v, setPRoundOff);
        console.log(pRoundOff)
        calcInvoice(productList, pOtherCharges, v);
        // }
    }

    const calcInvoice = (productlist, othercharges, proundoffother = 0) => {
        if (othercharges === '') {
            othercharges = 0;
        }

        console.log("qqqqq", othercharges)
        let forextotal = 0;
        let sgst = 0;
        let cgst = 0;
        let igst = 0;
        let tds = 0;
        let totalamount = 0;
        let taxablevalue = 0;
        let roundoff = 0;
        for (var i = 0; i < productlist.length; i++) {
            forextotal = forextotal + productlist[i].inv_amount * 1;
            sgst += parseFloat(((productlist[i].inv_taxable * productlist[i].inv_sgst) / 100).toFixed(2));
            cgst += parseFloat(((productlist[i].inv_taxable * productlist[i].inv_cgst) / 100).toFixed(2));
            igst += parseFloat(((productlist[i].inv_taxable * productlist[i].inv_igst) / 100).toFixed(2));
            tds = tds + ((productlist[i].inv_taxable * 1) / 100) * productlist[i].inv_tds * 1;

            taxablevalue = taxablevalue + productlist[i].inv_taxable * 1;
        }
        console.log("this ise me ", forextotal, sgst, cgst, igst, (1 * othercharges), roundoff)
        // totalamount = (forextotal + sgst + cgst + igst + (1 * othercharges) + tds).toFixed(2);
        totalamount = (forextotal + sgst + cgst + igst + (1 * othercharges) + (1 * proundoffother) + tds).toFixed(2);
        // roundoff = Math.round(totalamount) - totalamount;

        console.log("aaaaaaaaaaaaaa", totalamount);
        setPForexTotal(forextotal.toFixed(2));
        setPSgst(sgst.toFixed(2));
        setPTaxableVal(taxablevalue.toFixed(2));
        // setPRoundOff(roundoff);
        setPRoundOff(proundoffother);
        setPCgst(cgst.toFixed(2));
        setPIgst(igst.toFixed(2));
        setPTotalAmount(totalamount);
        setPUgst(0);
        var amt = 0;
        for (var i = 0; i < paymentData.length; i++) {
            amt += paymentData[i].tp_amount * 1;
        }
        setPdAmount((1 * totalamount - amt).toFixed(2));
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            productRef.current.focus();
        }
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
        setPdGroupValue(id[1]);
        setPdAccountValue(id[2]);
    }

    const handlePaymentType = (v) => {
        $(".loader").show();
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setPdAccount(null);
        setPdAccountValue(0);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH") {
            ldgType = "CASH";
        } else if (v === "BN" || v === "CQ") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "RC") {
            if (nParty !== null) {
                setPdAccount(nParty);
                setDisablePaymentAccount(true);
                $(".loader").hide();
                return;
            }
        }
        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }

    const addNewForm = () => {
        var d = Common.dateYMD(siNewDate);
        var ddmy = Common.dateDMY(siNewDate);
        var today = Common.dateYMD(new Date());
        if (siLocation == null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        }
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (d == today) {
                addNewFormResetFields(ddmy);
            } else {
                const obj = {
                    billdate: d,
                    location: siLocationValue,
                    type: "SI"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields(ddmy);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }


    const addNewFormResetFields = (ddmy) => {
        setHdrDate(ddmy);
        setScrMode('A');
        setKey('INFO');
        setHdrSrno(0);

        setNBillDate(new Date(Common.dateYMD(siNewDate)));
        setNParty(null);
        setNStateReceiver(null);
        setNGstin("");
        setNTaxClass("");
        setNShipTo(null);
        setNPono("");
        setNPODate(null);
        setNEwayBillNo("");
        setNPaymentDueDate(siNewDate);
        setProductList([]);
        setPaymentData([]);
        setPTotalAmount(0);
        setPForexTotal(0);

        setSIParty(null);
        setNReverseCharge("1");
        setNManualBill("");
        setPOtherCharges(0);
        setHdrDateYmd("");
    }


    const addProduct = () => {
        var msg = [], i = 0;
        if (siParty === null || !pAmount || !pTaxable || (!gstDisable && !pFCgst) || (!gstDisable && !pFSgst) || (gstDisable && !pFIgst) || !pSac || pdescGdSrv === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (siParty === null ? " Account." : "");
            msg[i++] = (!pAmount ? " Amount." : "");
            msg[i++] = (!pTaxable ? " GST Taxable Value(INR)." : "");
            msg[i++] = ((!gstDisable && !pFCgst) ? " CGST." : "");
            msg[i++] = ((!gstDisable && !pFSgst) ? " SGST." : "");
            msg[i++] = ((gstDisable && !pFIgst) ? "IGST" : "");
            msg[i++] = (!pSac ? " SAC." : "");
            msg[i++] = (pdescGdSrv === "" ? " Description Of Services/Goods" : "");

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const sgstAmount = parseFloat(((Number(pTaxable) * Number(pFSgst)) / 100).toFixed(2));
            const cgstAmount = parseFloat(((Number(pTaxable) * Number(pFCgst)) / 100).toFixed(2));
            const igstAmount = parseFloat(((Number(pTaxable) * Number(pFIgst)) / 100).toFixed(2));
            // Total GST
            const totalGST = parseFloat((sgstAmount + cgstAmount + igstAmount).toFixed(2));
            let accnt = 0;
            let grp = 0;
            let ledger_name = "";
            let corp = siParty.id.split("^");
            grp = corp[1];
            accnt = corp[2];
            ledger_name = corp[3];
            const obj = {
                type: "PURCHASE",
                uniquekey: Common.getRandomString(15),
                inv_line_no: productLineNo,
                inv_location: siLocationValue,
                inv_type: 'SI',
                inv_group: grp,
                inv_account: accnt,
                mvli_ledger_name: ledger_name,
                inv_srno: hdrSrno,
                inv_date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(siNewDate),
                inv_amount: pAmount,
                inv_taxable: pTaxable,
                inv_qty: pQuantity,
                inv_rate: pRate,
                inv_sac: pSac,
                inv_tds: pTds === "" ? 0 : pTds,
                inv_tds1: pTds1 === "" ? 0 : pTds1,
                inv_sgst: pFSgst === "" ? 0 : pFSgst,
                inv_cgst: pFCgst === "" ? 0 : pFCgst,
                inv_igst: pFIgst === "" ? 0 : pFIgst,
                inv_pservice: pservice,
                inv_descgs: pdescGdSrv,
                inv_sgst_calc: pFSgst === "" ? 0 : ((pTaxable * pFSgst) / 100).toFixed(2),
                inv_cgst_calc: pFCgst === "" ? 0 : ((pTaxable * pFCgst) / 100).toFixed(2),
                inv_igst_calc: pFIgst === "" ? 0 : ((pTaxable * pFIgst) / 100).toFixed(2),
                inv_tds_calc: pTds === "" ? 0 : ((pAmount * pTds) / 100).toFixed(2),
                inv_tds1_calc: pTds1 === "" ? 0 : ((pAmount * pTds1) / 100).toFixed(2),
                inv_total_amount: parseFloat((Number(pAmount) + totalGST).toFixed(2)),
                prd_product: 'SI',
                prd_amount: pAmount,
                delny: "Y"
            }
            console.log("this is pl", obj)
            var productlist = Common.arrayAddItem(productList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                // TLine: productLineNo + 1,
                TLoc: siLocationValue,
                TType: 'SI',
                Group: grp,
                Ledger: accnt,
                Amount: pAmount,
                Taxable: pTaxable,
                SAC: pSac,
                TDS: pTds,
                SGST: pFSgst,
                CGST: pFCgst,
                IGST: pIgst,


            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setProductLineNo(productLineNo + 1);
            setProductList(productlist);
            setPAccount(null);
            setPAmount("");
            setPTaxable("");
            setPFCgst("");
            setPFSgst("");
            setPSac("");
            setPTds("");
            setPTds1("");
            setPRate("");
            setPService("");
            setPdescGdSrv("");
            setPIgst("");
            setPFIgst("");
            setPQuantity("");
            calcInvoice(productlist, pOtherCharges, (pRoundOff ?? 0));
            setSIParty(null);
        }
    }

    const addPayment = () => {
        console.log("Payment value is :", pdAccount);
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1 || (pdPaymentType === "BN" && pdChequeNum === "") || (pdPaymentType === "RC" && pdRemark === "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            msg[i++] = ((pdPaymentType === "RC" && pdRemark === "") ? "Remark " : '');
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (pdChequeNum === "" ? "Refernece Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                if (pdPaymentType === 'RC' || pdPaymentType === 'CH') {
                    accntname = a[4];
                } else {
                    accntname = a[5];
                }
            }
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo,
                tp_location: siLocationValue,
                tp_srno: hdrSrno,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                mvli_ledger_name: accntname,
                tp_amount: pdAmount,
                tp_cheque: pdChequeNum,
                tp_type: "SINV",
                prd_product: 'SI',
                tp_remark: pdRemark,
                delny: 'Y'
            }
            const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            if (existingItem) {
                existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
                existingItem.tp_remark = pdRemark;
                existingItem.tp_cheque = pdChequeNum;
            } else {
                const paymentdata = Common.arrayAddItem(paymentData, obj);
                setPaymentData(paymentdata);
                const obj2 = {
                    TabType: "Payment",
                    AType: "A",
                    ALineNo: tranAuditTrail.length + 1,
                    // TLine: paymentLineNo + 1,
                    TLoc: siLocationValue,
                    TType: 'SI',
                    PaymentType: pdPaymentType,
                    PaymentLedgerCode: accnt,
                    PaymentGroupCode: grp,
                    PaymentAccountName: accntname,
                    PaymentAmount: pdAmount,
                    // ...(pdPaymentType == "BN" ? {
                    ReferenceNo: pdChequeNum,
                    Remark: pdRemark,
                    // } : {}),

                }
                if (userRight.edit === "1" && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
                }
            }
            setPdPaymentType("");
            setPaymentLineNo(paymentLineNo + 1);
            setPdAmount("");
            setPdAccount(null);
            setPdRemark("");
            //setChequeValue(null);
            //setChequeLocation("");
            //setChequeSrno("");
            setCounter(counter + 1);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const deleteProduct = (value) => {
        const itemToDelete = productList.find(item => item.uniquekey === value);

        if (itemToDelete) {
            const formattedItem = {
                Product: itemToDelete.prd_product,
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: siLocationValue,
                TType: 'SINV',
                Group: itemToDelete.inv_group,
                Ledger: itemToDelete.inv_account,
                Amount: itemToDelete.inv_amount,
                Taxable: itemToDelete.inv_taxable,
                SAC: itemToDelete.inv_sac,
                TDS: itemToDelete.inv_tds,
                SGST: itemToDelete.inv_sgst,
                CGST: itemToDelete.inv_cgst,
                IGST: itemToDelete.inv_igst
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        const productlist = Common.arrayRemoveItem(productList, "uniquekey", value);
        setProductList(productlist);
        calcInvoice(productlist, pOtherCharges, pRoundOff);
        setCounter(counter - 1);
    }

    const deletePayment = (value, delny) => {
        const itemToDelete = paymentData.find(item => item.uniquekey === value);

        if (itemToDelete) {
            const formattedItem = {
                TabType: "Payment",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLine: paymentLineNo + 1,
                TLoc: siLocationValue,
                TType: 'SI',
                PaymentType: itemToDelete.tp_payment_type,
                PaymentGroupCode: itemToDelete.tp_group,
                PaymentLedgerCode: itemToDelete.tp_account,
                PaymentAccountName: itemToDelete.mvli_ledger_name,
                PaymentAmount: itemToDelete.tp_amount,
                ReferenceNo: itemToDelete.tp_cheque,
            };
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }

        }
        const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value);
        setPaymentData(paymentdata);
        var amt = 0;
        for (var i = 0; i < paymentdata.length; i++) {
            amt += paymentdata[i].tp_amount * 1;
        }
        setPdAmount(1 * pTotalAmount - amt);
        //}
        setCounter(counter - 1);
    }
    const handleManualNo = (value) => {
        setNManualno(value);
    }

    const saveData = () => {
        $(".loader").show();
        var totalinr = 0;
        for (var i = 0; i < paymentData.length; i++) {
            console.log("ME LOOP ME AAYA HU ")
            if (paymentData[i].tp_payment_type === "PB")
                totalinr -= paymentData[i].tp_amount * 1;
            else totalinr += paymentData[i].tp_amount * 1;
        }
        var msg = [], i = 0;
        if ((nParty === null) || (pTotalAmount != totalinr) || nStateReceiver.id === "" || nStateSupplier.id === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nParty === null ? "Party." : '');
            msg[i++] = (pTotalAmount != totalinr ? "Total amount of payment must be equal to calculated INR." : "");
            msg[i++] = (nStateReceiver.id === "" ? "State of Reciever can't be Empty." : "");
            msg[i++] = (nStateSupplier.id === "" ? "State of Supplier can't be Empty." : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            const obj = {
                srno: hdrSrno,
                type: 'SI',
                siLocationValue: siLocationValue,
                siNewDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(siNewDate),
                nBillDate: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(siNewDate),
                nManualBill: nManualBill,
                nManualNo: nManualNo,
                nParty: nParty,
                nStateReceiver: nStateReceiver === "" ? 0 : nStateReceiver,
                nStateSupplier: nStateSupplier === "" ? 0 : nStateSupplier,
                nGstin: nGstin,
                nTaxClass: nTaxClass === "" ? 0 : nTaxClass,
                nShipTo: nShipTo,
                nPono: nPono,
                nPODate: Common.dateYMD(nPODate),
                nEwayBillNo: nEwayBillNo,
                nPaymentDueDate: Common.dateYMD(nPaymentDueDate),
                nReverseCharge: nReverseCharge,
                nRemark1: nRemark1,
                nRemark2: nRemark2,
                pForexTotal: pForexTotal,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pOtherCharges: pOtherCharges === "" || pOtherCharges == null ? 0 : pOtherCharges,
                pRoundOff: pRoundOff == "" ? 0 : pRoundOff,
                pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
                pTotalAmount: pTotalAmount,
                productList: productList,
                paymentData: paymentData,
            }
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (userRight.edit === "1" && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'SI', siLocationValue));
            }
            Common.callApi(Common.apiTranSI, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    $(".loader").hide();
                    setScrMode("");
                    let paramDate = Common.dateYMD(siNewDate);
                    if (hdrSrno > 0) {
                        paramDate = hdrDateYmd;
                    }
                    fillViewForm(resp.srno, paramDate);
                    var msg = "";
                    if (typeof resp.irn.Status !== "undefined") {
                        if (resp.irn.Status == "0") {
                            msg = ", IRN generation failed";
                            alert(JSON.stringify(resp.irn.ErrorDetails));
                        }
                    }
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg) + msg);
                    //listSIdata();
                    setTranAuditTrail([]);
                } else {
                    $(".loader").hide();
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg));
                }
            });
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: hdrSrno,
                    type: 'SINV',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'TRAN_SI'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                });
            }
        }
    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            nParty: { id: resp.acct_id, label: resp.acct_label },
            nBillDate: Common.dateYMD(siNewDate),
            nStateSupplier: { id: resp.supply_state_id, label: resp.supply_state_name },
            nGstin: resp.gstin,
            nTaxClass: resp.taxclass,
            nShipTo: { id: resp.ship_acct_id, label: resp.ship_acct_label },
            nPono: resp.pono,
            nPODate: resp.podate === null ? null : resp.podate,
            nEwayBillNo: resp.ewaybillno,
            nPaymentDueDate: resp.payment_due_date,
            nRemark1: nRemark1,
            nRemark2: nRemark2,
        };
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, date) => {
        setHdrSrno(hdrsrno);
        setKey('INFO');
        setViewDate(date);
        // setRandomString("0");
        $(".loader").show();
        const obj = {
            srno: hdrsrno,
            siLocationValue: siLocationValue,
            type: "SI"
        }
        Common.callApi(Common.apiTranSI, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                fillViewCompareObject(resp);
                $(".loader").hide();
                setScrMode("Q");
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);
                setNReverseCharge(resp.reversecharge);
                setNParty({ id: resp.acct_id, label: resp.acct_label });
                setNManualBill(resp.invoice);
                setNBillDate(resp.bill_date ? new Date(resp.bill_date) : null);
                setNPODate(resp.podate ? new Date(resp.podate) : null);
                setNPaymentDueDate(resp.payment_due_date ? new Date(resp.payment_due_date) : null);


                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);
                setHdrDate(resp.date);

                setProductLineNo(resp.maxlineno * 1);
                setProductList(resp.productlist);
                setPaymentLineNo(resp.paymaxlineno * 1);
                setPaymentData(resp.paydetails);
                setHdrSrno(resp.srno);
                setNGstin(resp.gstin);
                setNTaxClass(resp.taxclass);/////. ye thik karna h 
                setNStateReceiver({ id: resp.receiver_state_id, label: resp.receiver_state_name });
                setNStateSupplier({ id: resp.supply_state_id, label: resp.supply_state_name });
                setNPono(resp.pono);
                setNEwayBillNo(resp.ewaybillno);
                setNShipTo({ id: resp.ship_acct_id, label: resp.ship_acct_label });
                setCancelButtonView(resp.hdr_cancel_billYN === "1" ? false : true);
                var id = resp.acct_id;

                var location = id.split("^");
                if (location[3] === resp.supply_state_id) {
                    setGstDisable(false);
                } else {
                    setGstDisable(true);
                }
                const matchingOption = taxClassOPtions.find(val => val.value == location[14]);
                if (matchingOption) {
                    setNTaxClass(matchingOption.value);
                }
                setIsIrnGenerated(resp.isIrnGenerated);
                setIsIrnApplicable(resp.is_irn_applicable);

                setIsIrnGenerated(resp.isIrnGenerated);
                setIsIrnCancelled(resp.isIrnCancelled);
                setIrnCancelDate(resp.irncanceldt);
                setIrnCancelRemarkHdr(resp.irncancelrmk);
                setHdrDateYmd(resp.dateymd);
                if (resp.isIrnGenerated === "1") {
                    setIrnObj({
                        irn: resp.irn,
                        ackdate: resp.ackdate,
                        acknum: resp.ackno,
                        signedqr: resp.signedqr
                    });
                }

            }

        });
    }

    const listSIdata = () => {
        var msg = [], i = 0;
        $(".loader").show();
        if (siLocation === null || (radioType === 'S' && !siSrnoFrom) || (radioType === 'S' && !siSrnoTo) || (radioType === 'D' && !siFromDate)
            || (radioType === 'D' && !siToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (siLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !siSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !siSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !siFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !siToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                radioType: radioType,
                siLocation: siLocationValue,
                accountFilter: accountFilter,
                siNewDate: Common.dateYMD(siNewDate),
                siSrnoTo: siSrnoTo,
                siSrnoFrom: siSrnoFrom,
                siFromDate: Common.dateYMD(siFromDate),
                siToDate: Common.dateYMD(siToDate),
            }
            Common.callApi(Common.apiTranSI, [sid, "silist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setSIList(JSON.parse(result));
            });
        }
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        console.log(differenceInDays);

        const obj = {
            srno: hdrSrno,
            type: 'SI',
            pageright: 'TRAN_SI',
            location: siLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (productList.length > 0) {
                    setDisableOtherCharge(false);
                }
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SI', trannumber: hdrSrno, location: siLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "SI", trannumber: hdrSrno, trancategory: "T", location: siLocationValue });
    }

    const handleQuantityChange = (v) => {
        Common.validateNumValue(v, setPQuantity);
        setPRate("");
    }
    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        setPAmount((v * 1 * pQuantity * 1).toFixed(2));
        setPTaxable((v * 1 * pQuantity * 1).toFixed(2));
    }
    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: siLocationValue, trannumber: hdrSrno, type: 'SI' });
    }

    const print = () => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            location: siLocationValue,
            type: 'SI',
            printType: '',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }

    const handlePrint2 = () => {
        $(".loader").show();
        const obj = {
            srno: hdrSrno,
            location: siLocationValue,
            type: 'SI',
            printType: 'SIDet'
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        console.log(differenceInDays);

        const obj = {
            srno: hdrSrno,
            type: 'SI',
            pageright: 'TRAN_SI',
            location: siLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SI', trannumber: hdrSrno, location: siLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'SI',
            location: siLocationValue,
            srno: hdrSrno,
            productList: productList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listSIdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    const cancelBillFinalModal = () => {
        setMsgBoxCancelBill(true);
        setMsgTextCancelBill("Alert!");
        setIrnCancelDeclaration(false);
        setIrnCancelReason("");
        setIrnCancelLabel("I confirm the deletion of this bill.");
        setIrnCancelReasonSelect("");
    }

    const cancelBill = () => {
        const obj1 = {
            hdrSrno: hdrSrno,
            location: siLocationValue,
            type: 'SI',
            irnObj: irnObj,
            irnCancelReason: irnCancelReason,
            irnCancelReasonSelect: irnCancelReasonSelect
        }
        if (irnCancelReason === "") {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please fill reason.");
            return;
        }
        if (!irnCancelDeclaration) {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please check the declaration.");
            return;
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, 'cancelirn', JSON.stringify(obj1)], result => {
            $(".loader").hide();
            setMsgBoxCancelBill(false);
            let resp = JSON.parse(result);
            if (resp.Status == "2") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.Status == "1") {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN cancelled successfully, Cancel Date " + resp.Data.CancelDate);
                } else {
                    alert(JSON.stringify(resp.ErrorDetails));
                }
            }
        });
    }


    const generateIrn = () => {
        const obj1 = {
            coporate: nParty,
            individual: null,
            location: siLocationValue,
            billdate: hdrDateYmd,
            hdrsrno: hdrSrno,
            type: 'SI',
            pForexTotal: pForexTotal,
            pSgst: pSgst,
            pIgst: pIgst,
            pUgst: pUgst,
            pCgst: pCgst,
            pOtherCharges: pOtherCharges,
            pRoundOff: pRoundOff,
            pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
            pTotalAmount: pTotalAmount,
            productList: productList,
            ppStateType: siStateType,
            ppStateValue: siStateValue,
            nState: nStateReceiver === "" ? 0 : nStateReceiver,
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, "generateirn", JSON.stringify(obj1)], result => {
            let resp = JSON.parse(result);
            if (resp.msg != "") {
                $(".loader").hide();
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                $(".loader").hide();
                if (resp.irn.Status == "0") {
                    alert(JSON.stringify(resp.irn.ErrorDetails));
                } else {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN Generated successfully.");
                }
            }
        });
    }

    const handleNextBill = () => {
        if (!hdrSrno || !siLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: siLocationValue,
            type: "SI"
        };

        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        })
    }
    const handlePrevBill = () => {
        if (!hdrSrno || !siLocationValue) {
            setMsgText("Bill Srno and Location required");
            setMsgBox(true);
        }

        // if hdrsrno and location available
        const obj = {
            srno: hdrSrno,
            location: siLocationValue,
            type: "SI"
        };

        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No Previous bill available.");
                setMsgBox(true);
            }
        })
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h1>Sale Invoice</h1>
                    </Col>
                    <hr />
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Form.Group>
                                    <Col style={{ display: "flex" }}>
                                        <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />&nbsp;
                                        <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                        <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                        {/* <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Individual" />  */}
                                    </Col>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={siLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLocationChange}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={siNewDate}
                                                    onChange={(date) => setSINewDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={siSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSISrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={siSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setSISrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            : radioType === "D" || radioType === "I" || radioType === "C" ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={siFromDate}
                                                                onChange={(date) => setSIFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={siToDate}
                                                                onChange={(date) => setSIToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" && radioType !== "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listSIdata()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.add === "1" && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Sr No </th>
                                            <th>Type</th>
                                            <th>Location</th>
                                            <th>Bill Date</th>
                                            <th>Account</th>
                                            <th>Total INR</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            siList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.new_date)} className='pointer colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.hdr_srno}</td>
                                                    <td>{item.hdr_type}</td>
                                                    <td>{item.entity_name}</td>
                                                    <td>{item.hdr_date}</td>
                                                    <td>{item.mvli_ledger_name}</td>
                                                    <td>{item.hdr_total_inr}</td>
                                                    <td>{item.hdr_date}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row style={{ display: (hdrSrno < 1 || isIrnApplicable === "N") && "none" }}>
                                <Col>
                                    {
                                        isIrnCancelled === "1" ?
                                            <div className='d-flex align-items-baseline'>
                                                <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>Bill Deleted</b></p>
                                                <p className='mx-2'>Delete Date : <b>{irnCancelDate}</b></p>
                                                <p className='mx-2'>Reason of Deletion: <b>{irnCancelReasonHdr}</b></p>
                                                <p className='mx-2'>Deletion Remark: <b>{irnCancelRemarkHdr}</b></p>
                                            </div>
                                            :
                                            <>
                                                {
                                                    isIrnGenerated === "1" ?
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "green" }}><FontAwesomeIcon icon={faCircleCheck} /></span> <b>IRN Generated</b></p>
                                                            {
                                                                userRight.delete === "1" &&
                                                                <Badge className='mx-2 pointer' bg='danger' onClick={cancelBillFinalModal}>Delete Bill</Badge>
                                                            }
                                                        </div>
                                                        :
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>IRN Generation Failed</b></p>
                                                            {
                                                                (userRight.add === "1" && scrMode === "Q") &&
                                                                <Badge className='mx-2 pointer' bg='warning' onClick={generateIrn}>Generate</Badge>
                                                            }
                                                        </div>
                                                }
                                            </>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button style={{ display: isIrnGenerated === "1" && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }

                                    {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print()}>Print</Button>&nbsp;
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => handlePrint2()}>Print 2</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                        </> : null}

                                    {(userRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1" && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : {hdrSrno}</Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocation} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='ppCharges'>
                                    <span><b>Forex Total (INR): {pForexTotal}</b></span>
                                    &nbsp;
                                    <span><b>Total Amount (INR): {pTotalAmount}</b></span>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Bill Date<span className='colorThemeRed'>*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nBillDate}
                                                    onChange={(date) => setNBillDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={true}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Manual Number</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nManualNo}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchManualTypePicklist(search, siLocationValue, 'SP')} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleManualNo}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col> */}
                                        <Col className='col-md-6 col-12'>
                                            <Form.Group>
                                                <Form.Label>Party/Bill To<span className='colorThemeRed'>*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nParty}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE  , DEALER, OTHER', siLocationValue)}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handlePartyChange}
                                                    isDisabled={scrMode === "Q" || productList.length > 0}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>State of Receiver/ Place of Supply</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nStateReceiver}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchStatePicklist(search, 1)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={(value) => setNStateReceiver(value)}
                                                    isDisabled={true}
                                                ></AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>

                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>State of Supplier</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nStateSupplier}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchStatePicklist(search, 1)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={(value) => setNStateSupplier(value)}
                                                    isDisabled={true}
                                                ></AsyncSelect>

                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>GSTIN</Form.Label>
                                                <Form.Control type="text" maxLength={30} placeholder='GSTIN' disabled={true} value={nGstin} onChange={e => setNGstin(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Tax Classification</Form.Label>
                                                <Form.Select
                                                    value={nTaxClass}
                                                    onChange={e => setNTaxClass(e.target.value)}
                                                    disabled={true}
                                                >
                                                    {taxClassOPtions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>


                                        </Col>
                                        <Col className='col-md-6 col-12'>
                                            <Form.Group>
                                                <Form.Label>Ship To</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nShipTo}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, siLocationValue)} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleShipChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>PO No.</Form.Label>
                                                <Form.Control type="text" maxLength={30} placeholder='PO No.'
                                                    value={nPono} onChange={e => setNPono(e.target.value)}
                                                    disabled={scrMode === "Q"} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>PO Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nPODate}
                                                    onChange={(date) => setNPODate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={scrMode === "Q"}
                                                    maxDate={new Date()}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label> E-way Bill No</Form.Label>
                                                <Form.Control type="text" maxLength={20} placeholder='E-wayBillNo' value={nEwayBillNo}
                                                    onChange={e => setNEwayBillNo(e.target.value)}
                                                    disabled={scrMode === "Q"} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Payment Due Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={nPaymentDueDate}
                                                    onChange={(date) => setNPaymentDueDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={scrMode === "Q"}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 1</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 2</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("DETAILS")}>Product-&gt;</Button>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="DETAILS" title="Details">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null :
                                            <>
                                                <Row>
                                                    <Col className='col-md-6 col-12'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className='colorThemeRed'>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={siParty}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, siLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleProductAccountChange}
                                                                isDisabled={scrMode === "Q"}
                                                                ref={productRef}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Quantity<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control type='text' placeholder='Quantity' value={pQuantity} maxLength={9}
                                                                onChange={e => handleQuantityChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Control type='text' placeholder='Rate' value={pRate} maxLength={Common.rateMaxLength}
                                                                onChange={e => handleRateChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Amount<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='Amount' type='text' maxLength={10} disabled={true} value={pAmount} onChange={e => Common.validateDecValue(e.target.value, setPAmount)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>GST Taxable Value(INR)<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='Amount' type='text' maxLength={10} value={pTaxable} onChange={e => Common.validateDecValue(e.target.value, setPTaxable)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>SGST %<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control disabled={gstDisable} placeholder='%' type='text' maxLength={4} value={pFSgst} onChange={e => Common.validateDecValue(e.target.value, setPFSgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>CGST %<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control disabled={gstDisable} placeholder='%' type='text' maxLength={4} value={pFCgst} onChange={e => Common.validateDecValue(e.target.value, setPFCgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>IGST %<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control disabled={!gstDisable} placeholder='%' type='text' maxLength={4} value={pFIgst} onChange={e => Common.validateDecValue(e.target.value, setPFIgst)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>SAC<span className='colorThemeRed'>*</span></Form.Label>
                                                            <Form.Control placeholder='SAC' type='text' maxLength={10} value={pSac} onChange={e => Common.validateDecValue(e.target.value, setPSac)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>TDS</Form.Label>
                                                            <Form.Control placeholder='%' type='text' maxLength={4} value={pTds} onChange={e => Common.validateDecValue(e.target.value, setPTds)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>TDS 1</Form.Label>
                                                            <Form.Control placeholder='%' type='text' maxLength={4} value={pTds1} onChange={e => Common.validateDecValue(e.target.value, setPTds1)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Is Service<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select value={pservice} onChange={e => setPService(e.target.value)}
                                                                required>
                                                                <option value="Y">YES</option>
                                                                <option value="N">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Description of Services/Goods<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                value={pdescGdSrv}
                                                                maxLength={500}
                                                                as="textarea"
                                                                placeholder="Leave a comment here"
                                                                style={{ height: '100px' }}
                                                                onChange={(e) => setPdescGdSrv(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>&nbsp;
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct()}>Add</Button>
                                                        &nbsp;
                                                        <Button variant='outline-secondary' className='buttonStyle' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment-&gt;</Button>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                            </>
                                    }
                                    <Row>
                                        <Table responsive bordered striped>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Ledger Name</th>
                                                    <th>Amount</th>
                                                    <th>Taxable Value</th>
                                                    <th>SGST</th>
                                                    <th>CGST</th>
                                                    <th>IGST</th>
                                                    <th>Total Amount</th>
                                                    <th>TDS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    productList.map((item) => (
                                                        <React.Fragment key={item.inv_line_no}>
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        scrMode === "Q" || item.delny === "N" ? null :
                                                                            <span onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span>
                                                                    }
                                                                </td>
                                                                <td>{item.inv_group}</td>
                                                                <td>{item.inv_account}</td>
                                                                <td>{item.mvli_ledger_name}</td>
                                                                <td>{item.inv_amount}</td>
                                                                <td>{item.inv_taxable}</td>
                                                                <td>{item.inv_sgst_calc}</td>
                                                                <td>{item.inv_cgst_calc}</td>
                                                                <td>{item.inv_igst_calc}</td>
                                                                <td>{item.inv_total_amount}</td>
                                                                <td>{item.inv_tds_calc}</td>

                                                            </tr>
                                                            <tr>
                                                                <td>&nbsp;</td>
                                                                <td colSpan={2}>
                                                                    <th>SAC:</th>
                                                                    <td>{item.inv_sac}</td>
                                                                </td>
                                                                <td colSpan={7}>
                                                                    <th>Description Good/Service</th>
                                                                    <td>{item.inv_descgs}</td>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>

                                    </Row>
                                </Tab>
                                <Tab eventKey="PAYMENT" title="Payments">
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>SGST: {pSgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>IGST: {pIgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>CGST : {pCgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>UGST : {pUgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Group>
                                                <Form.Label>Amount</Form.Label>
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pOtherCharges}
                                                    onChange={e => otherChargeChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Group>
                                                <Form.Label>Round off Amount</Form.Label>
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pRoundOff}
                                                    onChange={e => roundOffChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col>
                                            <h4>Payment Details</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    {/* <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Payment Type</Form.Label>
                                                            <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}>
                                                                <option value="">Select</option>
                                                                <option value="CH">Cash</option>
                                                                <option value="BN">Bank</option>
                                                                <option value="PB">Payables</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pdAccount}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, siLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleAccountValue}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col> */}
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Payment Type</Form.Label>
                                                            <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                            // onBlur={e => handlePaymentType(e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="CH">Cash</option>
                                                                <option value="BN">Bank</option>
                                                                <option value="RC">Recievables</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pdAccount}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, siLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleAccountValue}
                                                                isDisabled={pdPaymentType === "RC"}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        pdPaymentType !== "" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Amount</Form.Label>
                                                                    <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                </Form.Group>
                                                            </Col> : null
                                                    }
                                                </Row>
                                                {
                                                    pdPaymentType === "BN" ?
                                                        <Row>
                                                            <Col className="col-md-3 col-6">
                                                                <Form.Group>
                                                                    <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        : pdPaymentType === "RC" ?
                                                            <Row>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Remark<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control type="text" maxLength={255} placeholder='Remark' disabled={scrMode === "Q"} value={pdRemark} onChange={e => setPdRemark(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            : null
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Type</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Refernce No/Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentData.map((item, index) => (
                                                        <tr key={item.uniquekey}>
                                                            <td>
                                                                {
                                                                    scrMode !== "Q" ?
                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item.uniquekey, item.delny)}>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span> : null
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.tp_payment_type === "BN"
                                                                        ? "Bank" : item.tp_payment_type === "CQ"
                                                                            ? "Cheque" : item.tp_payment_type === "CH"
                                                                                ? "Cash" : item.tp_payment_type === "RC"
                                                                                    ? "Receivables" : item.tp_payment_type === "PB"
                                                                                        ? "Payables" : item.tp_payment_type === "AP"
                                                                                            ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                ? "Advance Received" : ""
                                                                }
                                                            </td>
                                                            <td>{item.tp_group}</td>
                                                            <td>{item.tp_account}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.tp_amount}</td>
                                                            <td>{item.tp_payment_type === "RC" ? item.tp_remark : item.tp_cheque}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>

                                </Tab>
                            </Tabs>
                            <hr />
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button style={{ display: isIrnGenerated === "1" && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }

                                    {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => print()}>Print</Button>&nbsp;
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => handlePrint2()}>Print 2</Button>&nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                        </> : null}

                                    {(userRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && userCancelBillRight.query === "1" && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <span className="corner-span">{counter}</span>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} billDetails={{ type: "SI", isirn: isIrnGenerated }} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Dialog_IRN
                isOpen={isMsgBoxCancelBill}
                onYes={(e) => cancelBill()}
                onNo={(e) => setMsgBoxCancelBill(false)}
                text={msgTextCancelBill}
                checkLabel={irnCancelLabel}
                irnCancelDeclaration={irnCancelDeclaration}
                setIrnCancelDeclaration={setIrnCancelDeclaration}
                irnCancelReason={irnCancelReason}
                setIrnCancelReason={setIrnCancelReason}
                irnCancelReasonSelect={irnCancelReasonSelect}
                setIrnCancelReasonSelect={setIrnCancelReasonSelect}
            />
        </>
    )
}

export default Tran_si